import { createSelector } from 'reselect';

const configGlobalReducerSelector = state => state.configGlobalReducer;

export const configVidrieraSelector = createSelector(
    configGlobalReducerSelector,
    (configGlobal) => configGlobal ? configGlobal.getIn(['data', 'configVidriera']) : undefined
);
